import React, { FC } from 'react'
import styles from './MyCollection.module.scss'
import { ProductList } from '~/modules/Products/Infrastructure/Components/ProductList/ProductList'
import { useTranslation } from 'next-i18next'
import { ComponentProductDto } from '~/modules/Products/Infrastructure/Dtos/ComponentProductDto'
import { UserHeader } from '~/modules/Auth/Infrastructure/Components/UserHeader'
import { CardCollectionComponentDto } from '~/modules/CardCollections/Infrastructure/CardCollectionComponentDto'
import { CardCollectionList } from '~/modules/CardCollections/Infrastructure/Components/CardCollectionList'
import { ProfileDto } from '~/modules/Profile/ProfileDto'
import { MarketBanner } from '~/components/MarketBanner'

interface Props {
  profile: ProfileDto
  products: Array<ComponentProductDto>
  cardCollections: Array<CardCollectionComponentDto>
}

export const MyCollection: FC<Props> = ({ profile, products, cardCollections }) => {
  const { t } = useTranslation('my_collection')

  const itemsCount = products.length
  let itemsCountTranslation = t('product_list_count_singular')

  if (itemsCount !== 1) {
    itemsCountTranslation = t('product_list_count_plural')
  }

  return (
    <section className={ styles.myCollection__container }>
      <MarketBanner/>

      <h1 className={ styles.myCollection__title }>
        { t('title') }
      </h1>

      <div className={ styles.myCollection__collectionHeader }>
        <h2 className={ styles.myCollection__collectionHeaderTitle }>
          { t('configuration_title') }
        </h2>
      </div>
      <UserHeader profile={ profile }/>

      <CardCollectionList cardCollections={ cardCollections } />

      <div className={ styles.myCollection__collectionHeader }>
        <h2 className={ styles.myCollection__collectionHeaderTitle }>
          { t('product_list_title') }
        </h2>

        { itemsCount } { itemsCountTranslation }
      </div>

      <ProductList products={ products } />
    </section>)
}
